import React from 'react';

import './style.scss';

export const FormInputBlock = ({ children, className = '' }) => {
	return <div className={`input-block ${className}`}>{children}</div>;
};
